import { presetRanges } from './config.js'
import date from '../../../utils/date.js'

export default function DateRangePlugin() {
  return function rangePlugin(fp) {
    const pluginData = {
      rangesNav: document.createElement('ul'),
      rangesOnly:
        typeof fp.config.rangesOnly === 'boolean'
          ? fp.config.rangesOnly
          : false,
      presetWithCalendar:
        typeof fp.config.presetWithCalendar === 'boolean'
          ? fp.config.presetWithCalendar
          : false,
      showRangeNav: false,
      buttons: {},
      ranges: [...presetRanges],
      calendarWidth: 300,
      rangesWidth: 300,
      labelFormat: 'MMM DD, YYYY',
    }

    function toDate(value, toString = false) {
      const newDate = date(value).toDate()
      if (toString) return newDate.toString()
      else return newDate
    }

    function setRangesNav(nav) {
      nav.classList.add('flat-pickr-ranges-nav')
      nav.classList.add('flatpickr-predefined-ranges')
      if (!pluginData.showRangeNav) {
        nav.style.display = 'none'
      }
      return nav
    }

    function rangeButtonLabel(range) {
      const start = date(range.start).format(pluginData.labelFormat)
      const end = date(range.end).format(pluginData.labelFormat)
      return `${start} - ${end}`
    }

    function addRangeButton(range) {
      const li = document.createElement('li')
      const btn = document.createElement('a')
      const strong = document.createElement('strong')
      const span = document.createElement('span')

      strong.innerHTML = range.label
      span.innerHTML = rangeButtonLabel(range)
      span.classList.add('ml-tiny')
      btn.appendChild(strong)
      btn.appendChild(span)
      li.appendChild(btn)
      pluginData.rangesNav.appendChild(li)
      range.li = li
      range.btn = btn

      return btn
    }

    function selectDate(range) {
      return function exectSetRange(e) {
        const { target } = e
        if (range.li.contains(target)) {
          let start = toDate(range.start)
          let end = toDate(range.end)

          if (!start) {
            fp.clear()
          } else {
            fp.setDate([start, end], true)
          }

          fp.close()
        }
      }
    }

    function selectActiveRangeButton([start, end]) {
      for (const [, range] of Object.entries(pluginData.ranges)) {
        if (
          toDate(start, true) === toDate(range.start, true) &&
          toDate(end, true) === toDate(range.end, true)
        ) {
          range.li.classList.add('active')
        } else {
          range.li.classList.remove('active')
        }
      }
    }

    function applyStyles() {
      applyContainerStyles()
      applyMonthStyles()
      applyCalendarStyles()
      appplyRangesStyles()
    }

    function applyContainerStyles() {
      let width

      if (pluginData.showRangeNav) {
        if (pluginData.presetWithCalendar) {
          width = `${pluginData.calendarWidth + pluginData.rangesWidth}px`
        } else {
          width = `${pluginData.rangesWidth}px`
        }
      } else {
        width = ''
      }

      fp.calendarContainer.style.width = width
    }

    function appplyRangesStyles() {
      let width = pluginData.rangesWidth
      let float = 'none'
      let display

      if (pluginData.showRangeNav) {
        if (pluginData.presetWithCalendar) {
          width = `${width - 10}px`
          float = 'right'
        }
        display = 'block'
      } else {
        display = 'none'
      }

      pluginData.rangesNav.style.display = display
      pluginData.rangesNav.style.width = width
      pluginData.rangesNav.style.float = float
    }

    function applyMonthStyles() {
      let width
      let float
      let display

      if (pluginData.showRangeNav) {
        if (pluginData.presetWithCalendar) {
          display = 'block'
        } else {
          display = 'none'
        }
        width = `${pluginData.calendarWidth}px`
        float = 'left'
      } else {
        width = ''
        float = 'none'
        display = 'block'
      }

      fp.monthNav.style.width = width
      fp.monthNav.style.float = float
      fp.monthNav.style.display = display
    }

    function applyCalendarStyles() {
      let float
      let display

      if (pluginData.showRangeNav) {
        if (pluginData.presetWithCalendar) {
          display = 'block'
        } else {
          display = 'none'
        }
        float = 'left'
      } else {
        float = 'none'
        display = 'block'
      }

      fp.innerContainer.style.float = float
      fp.innerContainer.style.display = display
    }

    function setCustomOpenhandler(fp) {
      fp.openPresetRange = function () {
        if (fp.config.presetRanges) {
          pluginData.showRangeNav = true
          applyStyles()
          fp.open()
        }
      }
    }

    const plugin = {
      onParseConfig() {
        fp.config.mode = 'range'
      },

      onReady(selectedDates) {
        if (fp.config.presetRanges) {
          setRangesNav(pluginData.rangesNav)

          for (const [, range] of Object.entries(pluginData.ranges)) {
            const btn = addRangeButton(range)
            const handler = selectDate(range)
            btn.addEventListener('click', handler)
            pluginData.buttons[range.label] = {
              handler,
              btn,
            }
          }

          fp.calendarContainer.insertBefore(
            pluginData.rangesNav,
            fp.innerContainer
          )
          fp.calendarContainer.classList.add('flatpickr-has-predefined-ranges')
          selectActiveRangeButton(selectedDates)
          applyStyles()
          setCustomOpenhandler(fp)
        }
      },

      onValueUpdate(selectedDates) {
        if (fp.config.presetRanges) {
          selectActiveRangeButton(selectedDates)
        }
      },

      onClose() {
        if (fp.config.presetRanges) {
          pluginData.showRangeNav = false
          applyStyles()
        }
      },
    }

    return plugin
  }
}
